import type { IDailyHealthRecord } from '@/hooks/useAppState';
import { formatLocalDate } from './utils';

export type CheckInMood = 'great' | 'calm' | 'tired';
export function displayCheckInMood(value: unknown): CheckInMood | '' {
  if (value === 'great') return 'great';
  if (value === 'normal' || value === 'calm') return 'calm';
  if (value === 'poor' || value === 'tired' || value === 'anxious') return 'tired';
  return '';
}
export function storeCheckInMood(value: CheckInMood): NonNullable<IDailyHealthRecord['mood']> {
  return value === 'tired' ? 'poor' : value === 'calm' ? 'normal' : 'great';
}

/** Preserve the existing member rules; check-ins and training use the same local day. */
export function healthTrainingAdjustment(records: IDailyHealthRecord[], isMember: boolean, now = new Date()) {
  const flags = { hr: false, sleep: false, mood: false };
  const today = formatLocalDate(now);
  const record = isMember ? records.find(r => r.date === today) : undefined;
  if (record) {
    const start = new Date(now);
    start.setDate(start.getDate() - 7);
    const startDate = formatLocalDate(start);
    const recent = records.filter(r => r.date >= startDate && r.date <= today
      && typeof r.restingHeartRate === 'number' && Number.isFinite(r.restingHeartRate));
    if (Number.isFinite(record.restingHeartRate) && recent.length >= 3) {
      const average = recent.reduce((sum, r) => sum + r.restingHeartRate!, 0) / recent.length;
      flags.hr = record.restingHeartRate! - average >= 8;
    }
    flags.sleep = typeof record.sleepHours === 'number' && record.sleepHours < 6;
    flags.mood = displayCheckInMood(record.mood) === 'tired';
  }
  const abnormalCount = Number(flags.hr) + Number(flags.sleep) + Number(flags.mood);
  return { abnormalCount, reductionPercent: abnormalCount === 1 ? 10 : abnormalCount === 2 ? 20 : 0,
    shouldRest: abnormalCount >= 3, abnormalFlags: flags };
}
